/**
 * @generated SignedSource<<d52e27377bf741828f63793e48d733ad>>
 * @relayHash 4d19c6540d37b16e1b72c88e8cf9cfa6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4710a8cf32c5f44f980814d755dda2c63144b50f8d772fc1ec2ce2b0ff5b4e92

import type { ConcreteRequest, Query } from 'relay-runtime';
export type CollectionsContextEntitlementsQuery$variables = {
  cloudId: string;
  skip: boolean;
};
export type CollectionsContextEntitlementsQuery$data = {
  readonly tenantContexts?: ReadonlyArray<{
    readonly confluenceEntitlementInfo: {
      readonly entitlement: {
        readonly relatesFromEntitlements: ReadonlyArray<{
          readonly entitlementId: string | null | undefined;
          readonly relationshipId: string | null | undefined;
          readonly relationshipType: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly jiraEntitlementInfo: {
      readonly entitlement: {
        readonly relatesFromEntitlements: ReadonlyArray<{
          readonly entitlementId: string | null | undefined;
          readonly relationshipId: string | null | undefined;
          readonly relationshipType: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly loomEntitlementInfo: {
      readonly entitlement: {
        readonly relatesFromEntitlements: ReadonlyArray<{
          readonly entitlementId: string | null | undefined;
          readonly relationshipId: string | null | undefined;
          readonly relationshipType: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type CollectionsContextEntitlementsQuery = {
  response: CollectionsContextEntitlementsQuery$data;
  variables: CollectionsContextEntitlementsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "hamsProductKey",
    "value": "confluence"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "relationshipId"
},
v4 = {
  "kind": "ScalarField",
  "name": "entitlementId"
},
v5 = {
  "kind": "ScalarField",
  "name": "relationshipType"
},
v6 = [
  {
    "kind": "LinkedField",
    "name": "entitlement",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "name": "relatesFromEntitlements",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ]
      }
    ]
  }
],
v7 = [
  {
    "kind": "Literal",
    "name": "hamsProductKey",
    "value": "loom"
  }
],
v8 = [
  {
    "kind": "Literal",
    "name": "hamsProductKey",
    "value": "jira-software"
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v10 = [
  (v9/*: any*/),
  {
    "kind": "LinkedField",
    "name": "entitlement",
    "plural": false,
    "selections": [
      (v9/*: any*/),
      {
        "kind": "LinkedField",
        "name": "relatesFromEntitlements",
        "plural": true,
        "selections": [
          (v9/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ]
      },
      {
        "kind": "ScalarField",
        "name": "id"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "CollectionsContextEntitlementsQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "alias": "confluenceEntitlementInfo",
                "args": (v2/*: any*/),
                "kind": "LinkedField",
                "name": "entitlementInfo",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": "entitlementInfo(hamsProductKey:\"confluence\")"
              },
              {
                "alias": "loomEntitlementInfo",
                "args": (v7/*: any*/),
                "kind": "LinkedField",
                "name": "entitlementInfo",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": "entitlementInfo(hamsProductKey:\"loom\")"
              },
              {
                "alias": "jiraEntitlementInfo",
                "args": (v8/*: any*/),
                "kind": "LinkedField",
                "name": "entitlementInfo",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": "entitlementInfo(hamsProductKey:\"jira-software\")"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CollectionsContextEntitlementsQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "alias": "confluenceEntitlementInfo",
                "args": (v2/*: any*/),
                "kind": "LinkedField",
                "name": "entitlementInfo",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": "entitlementInfo(hamsProductKey:\"confluence\")"
              },
              {
                "alias": "loomEntitlementInfo",
                "args": (v7/*: any*/),
                "kind": "LinkedField",
                "name": "entitlementInfo",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": "entitlementInfo(hamsProductKey:\"loom\")"
              },
              {
                "alias": "jiraEntitlementInfo",
                "args": (v8/*: any*/),
                "kind": "LinkedField",
                "name": "entitlementInfo",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": "entitlementInfo(hamsProductKey:\"jira-software\")"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4710a8cf32c5f44f980814d755dda2c63144b50f8d772fc1ec2ce2b0ff5b4e92",
    "metadata": {},
    "name": "CollectionsContextEntitlementsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "57f7192cdcb94cf46fef216a672be62d";

export default node;
